import React from 'react';

const UserReporting = () => <div>UserReporting</div>;

export default UserReporting;
